import React from 'react';
import _ from 'lodash';
import {
  Button, Divider, Grid, Typography,
} from '@material-ui/core';
import { getReferralInfo } from 'shared/helpers';
import styles from 'shared/styles';

export default function RateOnlySignup() {
  const referralInfo = getReferralInfo();
  const visible = !_.isNull(referralInfo);
  const welcomeString = `Welcome! Create your account or login to access rates for ${_.get(referralInfo, 'name')}`;
  return visible && (
  <>
    <Grid item xs={12}>
      <Typography style={{ textAlign: 'center', paddingTop: '10px', color: '#817f86' }}>
        {welcomeString}
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Button type="submit" style={styles.signupButton} href="https://share.hsforms.com/1XXjnC4V6SSqD2UTnJdoqFw8o22w">
        SIGN UP
      </Button>
    </Grid>
    <Grid item xs={12}>
      <Divider />
    </Grid>
    <Grid item xs={12}>
      <Typography style={{ color: '#817f86', fontSize: '14px' }}>
        Login for Existing Users
      </Typography>
    </Grid>
  </>
  );
}
